export default {
    methods: {
        /**
         * @param {Integer} billingCycle
         */
        billingCycle (billingCycle) {
            switch (Number(billingCycle)) {
                case 1:
                    return this.__('messages.units.monthly')
                case 3:
                    return this.__('messages.units.quarterly')
                case 6:
                    return this.__('messages.units.semiAnnually')
                case 12:
                    return this.__('messages.units.annually')
                case 24:
                    return this.__('messages.units.biennially')
                case 36:
                    return this.__('messages.units.triennial')
                case 60:
                    return this.__('messages.units.five_yearly')
                default:
                    return billingCycle
            }
        }
    }
}
